import React from "react";

/**
 * Where / When / What else, set beside the photograph.
 *
 * It is a GRID SIBLING of the image, not a positioned element. An earlier
 * version placed these with a guessed padding-top and drifted out of line the
 * moment a caption ran to two lines; being in the same grid row makes the
 * alignment structural instead of lucky.
 *
 * Renders nothing at all when the poster filled none of them in — which is the
 * point of the fields being optional.
 */
function MarginNote({ place, whenText, extraNote }) {
  const rows = [
    ["Where", place],
    ["When", whenText],
    ["What else", extraNote],
  ].filter(([, v]) => v);

  if (rows.length === 0) return null;

  return (
    <aside
      className="row-start-2 self-start max-[820px]:!row-auto
                 col-start-1 text-right border-r-2 border-dupontGold/30 pr-[16px]
                 group-[.flip]:col-start-3 group-[.flip]:text-left
                 group-[.flip]:border-r-0 group-[.flip]:border-l-2
                 group-[.flip]:pr-0 group-[.flip]:pl-[16px]
                 max-[820px]:!col-auto
                 max-[820px]:!order-none max-[820px]:!text-left
                 max-[820px]:!border-r-0 max-[820px]:!border-l-2
                 max-[820px]:!pl-[12px] max-[820px]:!pr-0
                 max-[820px]:flex max-[820px]:flex-wrap max-[820px]:items-baseline
                 max-[820px]:gap-x-[18px] max-[820px]:gap-y-[2px]"
    >
      {rows.map(([label, value]) => (
        <React.Fragment key={label}>
          <span className="block font-blairBody font-semibold text-[12px] tracking-[0.16em]
                           uppercase text-dupontGold mb-[4px] max-[820px]:mb-0">
            {label}
          </span>
          <span className="block font-marginNote text-[15.5px] leading-[1.35] font-semibold text-dupontBlue
                           dark:text-gray-200 mb-[13px] last:mb-0 max-[820px]:mb-0 max-[820px]:mr-[10px]
                           break-words [overflow-wrap:anywhere] min-w-0">
            {value}
          </span>
        </React.Fragment>
      ))}
    </aside>
  );
}

export default MarginNote;
